import { type MessageDescriptor, type WrappedComponentProps } from 'react-intl-next';

export enum ItemModuleCompleteKeys {
	BLANK_PAGE = 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-page',
	PRODUCT_REQUIREMENTS = 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item',
	DECISION = 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item',
	MEETING_NOTES = 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item',
	RESTROSPECTIVE = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-item',

	// added for MSR experiment
	PROJECT_PLAN = 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-item',
	ONE_ON_ONE_MEETING = 'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-item',
	NINETY_DAY_PLAN = 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-item',
	FIVE_WHYS_ANALYSIS = 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-item',
	HOW_TO_ARTICLE = 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-item',
	PRODUCT_ROADMAP = 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-item',
	BRAINSTORMING = 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-item',
	AWS_ARCHITECTURE_DIAGRAM = 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-item',
	MASTER_PROJECT_DOCUMENT = 'com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-item',
	SOFTWARE_ARCHITECTURE_REVIEW = 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-item',
	COMPETITIVE_ANALYSIS = 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-item',
	BUSINESS_PLAN_ONE_PAGER = 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-item',
	BUSINESS_PROPOSAL = 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-proposal-item',
	TO_DO_LIST = 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-item',
}

export enum BlueprintModuleCompleteKeys {
	PRODUCT_REQUIREMENTS = 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
	DECISION = 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
	MEETING_NOTES = 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
	RESTROSPECTIVE = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',

	// added for MSR experiment
	PROJECT_PLAN = 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
	ONE_ON_ONE_MEETING = 'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
	NINETY_DAY_PLAN = 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
	FIVE_WHYS_ANALYSIS = 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
	HOW_TO_ARTICLE = 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
	PRODUCT_ROADMAP = 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
	BRAINSTORMING = 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
	AWS_ARCHITECTURE_DIAGRAM = 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
	MASTER_PROJECT_DOCUMENT = 'com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-blueprint',
	SOFTWARE_ARCHITECTURE_REVIEW = 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
	COMPETITIVE_ANALYSIS = 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
	BUSINESS_PLAN_ONE_PAGER = 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
	BUSINESS_PROPOSAL = 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-proposal-blueprint',
	TO_DO_LIST = 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
}

export type BlueprintModuleCompleteKey = BlueprintModuleCompleteKeys | null;

export type ItemModuleCompleteKey = ItemModuleCompleteKeys | null;

export type WithIntlProps<T> = T & WrappedComponentProps;

export interface GenericButtonOptions {
	text: MessageDescriptor;
	onClick: () => void;
	isLoading: boolean;
	onReady?: () => void;
}
